import { BackgroundPriority } from '@atlassian/jira-non-critical/src/BackgroundPriority.tsx';

/**
 * Re-export of BackgroundPriority indicating the intent of its use. Meaning "all hydration across the app has finished".
 */
export const RenderAfterHydrationCompletion = BackgroundPriority;
